import { BtnProps } from './reducer'


export enum ColumnActions {
    SET_BUTTON_PROPS = 'SET_BUTTON_PROPS',
    SET_IS_SERVICABLE = 'SET_IS_SERVICABLE',
}

interface SetBtnProps {
    type: typeof ColumnActions.SET_BUTTON_PROPS,
    payload: [BtnProps, BtnProps],
}

export type ColumnActionTypes = (
    SetBtnProps
)